import type ProductWizardController from "../product_wizard_controller";
import { DecorSuiteFormsSearchableSelectIdentifier } from "decor";

/** HTML-escape a string to prevent XSS in innerHTML assignments. */
export function esc(text: string): string {
  const div = document.createElement("div");
  div.textContent = text;
  return div.innerHTML;
}

/**
 * Read the display label for a SearchableSelect component by field name.
 * Falls back to choices JSON, then the raw hidden input value.
 */
export function getSearchableSelectLabel(
  controller: ProductWizardController,
  fieldName: string,
): string {
  const hiddenInput = controller.element.querySelector(
    `input[type="hidden"][name*="[${fieldName}]"]`,
  ) as HTMLInputElement | null;
  if (!hiddenInput?.value) return "";

  const component = hiddenInput.closest(
    '[data-controller*="searchable-select"]',
  );
  if (component) {
    const labelSpan = component.querySelector(
      `[data-${DecorSuiteFormsSearchableSelectIdentifier}-target="selectedLabel"]`,
    );
    if (labelSpan?.textContent?.trim()) {
      return labelSpan.textContent.trim();
    }

    // Fallback: try to find label from choices data attribute
    const choicesStr =
      component.getAttribute(
        `data-${DecorSuiteFormsSearchableSelectIdentifier}-choices-value`,
      ) || "[]";
    try {
      const choices = JSON.parse(choicesStr) as Array<{
        id: string;
        label: string;
      }>;
      const match = choices.find((c) => String(c.id) === hiddenInput.value);
      if (match) return match.label;
    } catch {
      // ignore parse errors
    }
  }

  // Last resort: return the raw value
  return hiddenInput.value;
}

/** Read the current price UoM value from the form. */
export function getCurrentPriceUom(
  controller: ProductWizardController,
): string {
  const input = controller.element.querySelector(
    '[name*="[default_price_uom]"]',
  ) as HTMLInputElement | HTMLSelectElement | null;
  return input?.value || "";
}
